export class MinifiedSelection {
	constructor(
		public selectionName: string,
		public isVisible: boolean,
		public orderBy: number,
		public aggregateFunctionId?: number,
	) { }
}
